import { useState, useEffect } from 'react';
import { TextField, InputLabel, FormControl, InputAdornment, Button, Typography, LinearProgress, Stack, Grid, Select, MenuItem,Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions  } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import {sendMobileOtp,verifyOtpEmployer, createPassword, EmployeeView } from '../../sevices/account'
import './style.scss'
import { ENV_CONFIG, VALIDATION_MSG ,useValidation} from '../../constant';
import { isEmptyObj} from '../../utils/genericUtilities';
import { Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import CustomSnackBar from '../../shared/snackBar';
import DoneIcon from '@mui/icons-material/Done';
import { MuiOtpInput } from 'mui-one-time-password-input';
import axios from 'axios';

// CREATE PASSWORD FUNCTION 
const CreatePasswordComponent = () => {
  const [errorPopupOpen, setErrorPopupOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [customMsg, setCustomMsg] = useState({});
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [strength, setStrength] = useState([])
  const [error, setError] = useState('')
  const [numberVerified, setNumberVerified] = useState(false);
  const [phone, setPhone] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState('');
  const [isMobileResend, setIsMobileResend] = useState(false);
  const [mobileTimer, setMobileTimer] = useState(30);
  const [phoneError, setPhoneError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [validationError, setValidationError] = useState(''); // Define confirm password error state
  const [employeeProfile, setEmployeeProfile] = useState({});
  const [docType, setDocType] = useState('PAN')
  const [aadharStatus, setAadharStatus] = useState(false);
  const [panStatus, setPanStatus] = useState(false);
  const docmentError = ''

// DOCTYPE SET VALUE FUNCTION 
  const handleDocValueChange = (event) => {
    setDocType(event.target.value);
  };

  // SNACKBAR FUNCTION 
  const handleSnackbarClick = (status, msgInfo) => {
    setOpenSnackbar(status);
    !isEmptyObj(msgInfo) && setCustomMsg(msgInfo);
  };

  useEffect(() => {
    let interval = 0;

    if (mobileTimer > 0 && isMobileResend) {
      interval = setInterval(() => {
        setMobileTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }
  
      if(isMobileResend && mobileTimer === 0){
        setIsMobileResend(false)
      }
    return () => clearInterval(interval);
  }, [mobileTimer, isMobileResend]);




  const navigate = useNavigate();

  const {
    password,
    setPassword,
    passwordError,
    confirmPassword,
    setConfirmPassword,
    setPasswordError,
    confirmPasswordError,
    handleConfirmPasswordBlur,
    handlePasswordBlur,
    setAadharNum,
    setPanNum,
    aadharError,
    panError,
    aadharNum,
    panNum,
    handleAdharBlur,
    handlePanBlur,
  } = useValidation();

  // PHONE PATTERN  VALIDATION FUNCTION 
  const validatePhone = (phoneNum) => {
    const phonePattern = /^[0-9]{10}$/;
    if (!phonePattern.test(phoneNum)) {
      setPhoneError('Invalid phone number');
    } else {
      setPhoneError('');
    }
  };

  // PHONE VALIDATION FUNCTION 
  const handleChange = (fieldName) => (event) => {
    if (fieldName === 'phone') {
      const value = event.target.value;
      const sanitizedInput = value.replace(/[^0-9]/g, '').slice(0, 10);
      if (sanitizedInput.length <= 10) {
        setPhone(sanitizedInput);
      }
    }
    if (fieldName === 'otp') {
      const numericValue = event.replace(/\D/g, '');
      setOtp(numericValue);
    }
  };

  const queryParams = new URLSearchParams(window.location.search);
  const forget = queryParams.get('reset');
  const ResetToken = queryParams.get('data');
  const userId = queryParams.get('id');

  // PHONE VALUE SET FUNCTION 
  const handlePhoneChange = (e) => {
    const { value } = e.target;
    handleChange("phone")(e);
    validatePhone(value);
  };

  // HANDLE PASSWORD SHOW FUNCTION 
  const handleClickShowPassword = (field) => {
    if (field === 'password') {
      setShowPassword(!showPassword);
    } else if (field === 'confirmPassword') {
      setShowConfirmPassword(!showConfirmPassword);
    }
  };
 

  useEffect(() => {
    setLoading(true);
    if (employeeProfile.verified) {
      navigate('/account-verify-successful');
      return
    } else if (employeeProfile.phone) {
      setPhone(employeeProfile.phone);
    setLoading(false);

    }
  }, [employeeProfile, navigate]);

 // EMPLOYER OTP VERIFICATION API FUNCTION 

  const otpVerify = async () => {
    setLoading(true);
    const data = {
      phone: `+91${phone}`,
      otp,
    }
    try {
      const response = await verifyOtpEmployer(data);
      if (response?.status === 200) {
        if (response?.data?.details?.Status === "Success") {
          setNumberVerified(true)
        } else {
          handleSnackbarClick(true, { type: 'error', msg: 'Enter Valid OTP' })
          setOtpSent(false)
        }
        setLoading(false);
      }
    } catch (err) {
      handleSnackbarClick(true, { type: 'error', msg: 'Something Went Wrong' })
    }


  }

  // AADHAR VERIFICATION FUNCTION 
  const aadhaarVerify =  () => {
    const requestBody = {
      id_number: aadharNum,
    };

    axios.post('https://kyc-api.surepass.io/api/v1/aadhaar-validation/aadhaar-validation', requestBody, {
      headers: {
        'Authorization': `Bearer ${ENV_CONFIG.AUTH_TOKEN}`,
        'Content-Type': 'application/json', // Specify the content type as JSON
      },
    })
      .then(response => {
        handleSnackbarClick(true, { type: 'success', msg: "Verification Success" })
        setAadharStatus(response?.data?.success)
      })
      .catch(adharErr => {
        handleSnackbarClick(true, { type: 'error', msg: adharErr?.response?.data?.message })
      });
  }

// PAN VERIFICATION FUNCTION 
  const panVerify =  () => {
    const requestBody = {
      id_number: panNum,
    };

    axios.post('https://kyc-api.surepass.io/api/v1/pan/pan', requestBody, {
      headers: {
        'Authorization': `Bearer ${ENV_CONFIG.AUTH_TOKEN}`,
        'Content-Type': 'application/json', // Specify the content type as JSON
      },
    })
      .then(response => {
        handleSnackbarClick(true, { type: 'success', msg: "Verification Success" })

        setPanStatus(response?.data?.success)
      })
      .catch(verifyErr => {
        handleSnackbarClick(true, { type: 'error', msg: verifyErr?.response?.data?.message })
      });
  }

  // MOBILE OTP SEND FUNCTION 
  const otpSend = async () => {
    setLoading(true);
    const data = {
      "phone": `+91${phone}`
    }
    try {
      const response = await sendMobileOtp(data);
      if (response?.status === 200) {
        setLoading(false);
        setOtpSent(true)
        setIsMobileResend(true);
        setMobileTimer(30);
        if (response?.data?.message === "Failed to send OTP") {
          setOtpSent(false)
          handleSnackbarClick(true, { type: 'error', msg: "Failed to send OTP" })

        }
      } 
    } catch (err) {
      setLoading(false);
      handleSnackbarClick(true, { type: 'error', msg: err?.response?.data?.errors?.message })
    }
  }

  // HANDLE PASSWORD FUNCTION 
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };



// POPUP FUNCTION 

  const ErrorPopup = () => {
    return (
      <Dialog open={errorPopupOpen} onClose={() => setErrorPopupOpen(false)} >
        <DialogTitle>Error</DialogTitle>
        <DialogContent>
          <DialogContentText style={{ width: error === 'User not found' && '300px' }}>
            {error ? error : 'Incorrect username or password. Please try again.'}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setErrorPopupOpen(false)}>OK</Button>
        </DialogActions>
      </Dialog>
    );
  };

  // UPDATE STRENGTH FUNCTION 
  const updateStrength = (criteriaName, condition) => {
    const isValuePresent = strength.some((item) => item?.[criteriaName] === true);
    if (!isValuePresent && condition) {
      setStrength([...strength, { [criteriaName]: true }]);
    }
  };

  // CHANGE PASSWORD FUNCTION 
  const handleChangePassword =  (e) => {
    const newPassword = e.target.value;
    updateStrength('passwordLength', newPassword.length < 6);
    updateStrength('Uppercase', /[A-Z]/.test(newPassword));
    updateStrength('Lowercase', /[a-z]/.test(newPassword));
    updateStrength('number', /\d/.test(newPassword));
    updateStrength('symbol', /[!@#$%^&*]/.test(newPassword));
    setPassword(newPassword);

    if (!newPassword) {
      setStrength([]);
    }
  }
 
// EMPLOYER PROFILE VIEW API FUNCTION 
  const getEmployeeProfile = async () => {

    try {
      const response = await EmployeeView(parseInt(userId));
      setEmployeeProfile(response?.data?.details)
    } catch (fetchError) {
      console.log("ERRORR",fetchError)
    }
  }

  // NEW PASSWORD API FUNCTION 
  const HandleNewPassword = async () => {
    // Clear previous errors
    setConfirmPassword();
    setPasswordError('');
    setValidationError('');
    setError('');

    // Check if phone number is provided and verified
    if (!phone) {
      return setValidationError(VALIDATION_MSG.phoneRequired);
    }
    if (!numberVerified) {
   
      setPhoneError('Mobile number not verified');
    } else {
  
      setPhoneError('');
    }

    // Check if there is an existing phone error
    if (phoneError) {
      return setValidationError(phoneError);
    }


    // Validate password
    if (!password) {
      return setPasswordError(VALIDATION_MSG.passwordRequired);
    }
    if (password.length < 8) {
      return setPasswordError('Password must be at least 8 characters long.');
    }
    if (!/[A-Z]/.test(password)) {
      return setPasswordError('Password must contain at least one uppercase letter.');
    }
    if (!/[a-z]/.test(password)) {
      return setPasswordError('Password must contain at least one lowercase letter.');
    }
    if (!/\d/.test(password)) {
      return setPasswordError('Password must contain at least one number.');
    }
    if (!/[!@#$%^&*]/.test(password)) {
      return setPasswordError('Password must contain at least one special character.');
    }

    // Validate confirm password
    if (!confirmPassword) {
      return setValidationError(VALIDATION_MSG.confirmPassword);
    }

    if (password !== confirmPassword) {
      return setValidationError(VALIDATION_MSG.passwordMismatch);
    }

    if (password.length < 8) {
      return setValidationError('Password must be at least 8 characters long.');
    }

    const body = {
      token: ResetToken,
      password,
      verified: numberVerified,
      id: userId
    };

    setLoading(true);

    try {
      const response = await createPassword(body);
      if (response?.status === 200) {
        setLoading(false);
        navigate('/account-verify-successful');
      }
    } catch (err) {
      setLoading(false);
      setError(err.response.data.message);
      setErrorPopupOpen(true);
    }
    return null;
  };

// GOBACK FUNCTION 
  const handleGoBack = () => {
    navigate(-1);
  };
  const displayPhone = `XXXXXX${phone.substr(-4)}`;

  useEffect(() => {
    getEmployeeProfile()
  }, [])

  return (
    <div className="SinginFormRight">
      {loading && (
        <div className="SiginLoader">
          <Spin spinning />
        </div>
      )}
      <a onClick={handleGoBack} >
        <img src={require('../../assets/images/Logo Blue TM.png')} className="SinginFormLogo" alt="" />
      </a>
      <div className="SinginFormTitleContainer">
        <span className="SinginFormTitle">
          Find your perfect part time job
        </span>
        <span>{forget || ResetToken ? null : "Sign in to your account"}</span>
      </div>
      <div className="SinginFormPageContainer">
        <FormControl className="form-control">
          <div className='create-password-page-label label-with-input'>{otpSent ? '' : 'Phone'}</div>
          <Grid item xs={12} sm={12}>
            {numberVerified ? (
              <TextField
                id="phone_number"
                className="form-control"
                value={displayPhone}
                InputProps={{
                  type: 'text',
                  maxLength: 10,
                  pattern: '[0-9]*',
                  endAdornment: (
                    <InputAdornment position="end">
                      <DoneIcon className="phoneVerifyIcon" />
                    </InputAdornment>
                  ),
                }}
                inputlabelprops={{ shrink: true }}
              />
            ) : otpSent ? (
              <div className="verifyOtpInput">
                <MuiOtpInput
                  value={otp}
                  onChange={handleChange("otp")}
                  inputProps={{
                    inputMode: 'numeric',
                    pattern: '[0-9]*',
                  }}
                />
                <div className='d-flex w-100 align-center' style={{ justifyContent: 'space-between' }}>
                  <Button className="phoneVerifyBtn" onClick={otpVerify}>
                    Verfiy OTP
                  </Button>
                  <Button
                    style={{ textTransform: "unset", float: 'right' }} variant="text"
                    disabled={isMobileResend && mobileTimer !== 0}
                    onClick={otpSend}
                  >
                    {isMobileResend && mobileTimer !== 0
                      ? `Resend OTP in ${mobileTimer} seconds`
                      : 'Resend OTP'
                    }
                  </Button>
                </div>
              </div>
            ) : (
              <TextField
                id="phone_number"
                className="form-control"
                value={displayPhone}
                onChange={handlePhoneChange}
                error={Boolean(phoneError)}
                helperText={phoneError}
                inputProps={{
                  type: 'text',
                  maxLength: 4, // Display only last 4 digits
                  pattern: '[0-9]*',
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Button className="phoneVerifyBtn" onClick={otpSend} >
                        Send OTP
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />
            )}
          </Grid>
        </FormControl>
        <Grid container spacing={2}>
          <Grid item xs={4} sm={4}>
            <FormControl className="form-control">
              <div className='create-passsword-page-label'>Select Document For Verification</div>
              <Select
                labelId="aadhar_number"
                id="aadhar_number"
                value={docType}
                onBlur={handleDocValueChange}
                onChange={handleDocValueChange}
                inputlabelprops={{ shrink: true }}
              >
                <MenuItem value={"PAN"}>PAN</MenuItem>
                <MenuItem value={"Aadhar"}>Aadhar</MenuItem>
              </Select>
              <p className="selecInput">{docmentError}</p>
            </FormControl>
          </Grid>
          <Grid item xs={8} sm={8}>
            {docType === "Aadhar" ? (
              aadharStatus ? (
                <>
                  <div className='create-passsword-page-label label-with-input'>Aadhar Number</div>
                  <TextField
                    id="aadhar_number"
                    className="form-control"
                    value={aadharNum}
                    shrink={false}
                    InputProps={{
                      type: 'text',
                      endAdornment: (
                        <InputAdornment position="end">
                          <DoneIcon className="phoneVerifyIcon" />
                        </InputAdornment>
                      ),
                    }}
                    inputlabelprops={{ shrink: true }}
                  />
                </>
              ) : (
                <>
                  <div className='create-passsword-page-label label-with-input'>Aadhar Number</div>
                  <TextField
                    id="aadhar_number"
                    className="form-control"
                    error={Boolean(aadharError)}
                    helperText={aadharError}
                    value={aadharNum}
                    onBlur={handleAdharBlur}
                    placeholder='Enter your Aadhar no'

                    onChange={(event) => {
                      const aadharNumber = event.target.value;
                      if (aadharNumber.length <= 12) {
                        const numericInput = aadharNumber.replace(/\D/g, '');
                        setAadharNum(numericInput);
                      }
                    }}
                    InputProps={{
                      inputMode: 'numeric',
                      endAdornment: (
                        <InputAdornment position="end">
                          {aadharNum ? (
                            <Button className="phoneVerifyBtn" onClick={aadhaarVerify}>
                              Verify
                            </Button>
                          ) : null}
                        </InputAdornment>
                      ),
                    }}
                  /></>
              )
            ) : docType === "PAN" ? (
              panStatus ? (
                <>
                  <div className='create-passsword-page-label label-with-input'>PAN No</div>
                  <TextField
                    id="pan_number"
                    className="form-control"
                    value={panNum}
                    InputProps={{
                      type: 'text',
                      endAdornment: (
                        <InputAdornment position="end">
                          <DoneIcon className="phoneVerifyIcon" />
                        </InputAdornment>
                      ),
                    }}
                    inputlabelprops={{ shrink: true }}
                  /></>
              ) : (
                <>
                  <div className='create-passsword-page-label label-with-input'>PAN No</div>
                  <TextField
                    id="pan_number"
                    className="form-control"
                    error={Boolean(panError)}
                    helperText={panError}
                    value={panNum}
                    placeholder='Enter your PAN no'

                    onBlur={handlePanBlur}
                    onChange={(event) => {
                      const panNumber = event.target.value;
                      if (panNumber.length <= 10) {
                        const numericInput = panNumber.replace(/\s/g, '').toUpperCase();
                        setPanNum(numericInput);
                      }
                    }}
                    InputProps={{
                      inputMode: 'numeric',
                      endAdornment: (
                        <InputAdornment position="end">
                          {panNum ? (
                            <Button className="phoneVerifyBtn" onClick={panVerify}>
                              Verify
                            </Button>
                          ) : null}
                        </InputAdornment>
                      ),
                    }}
                  />
                </>

              )
            ) : (
              <>
                {/* <div className='create-passsword-page-label label-with-input'>PAN No</div> */}
                <TextField
                  id="pan_number"
                  className="form-control"
                  value={panNum}
                  onBlur={handlePanBlur}
                  onChange={() => {
                    handleSnackbarClick(true, { type: 'error', msg: "Please select document for verification" });
                  }}
                /></>
            )}
          </Grid></Grid>



        <FormControl className="form-control">
          <InputLabel htmlFor="name-input">Create Password</InputLabel>
          <Stack
            spacing={0.5}
            sx={{
              '--hue': Math.min(strength?.length * 10, 120),
            }}
          >
            <TextField
              variant="outlined"
              type={showPassword ? 'text' : 'password'}
              error={Boolean(passwordError)}
              helperText={passwordError}
              value={password}
              name='password'
              placeholder='New password'
              onBlur={handlePasswordBlur}
              onChange={handleChangePassword}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => handleClickShowPassword('password')}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              maxLength={10}
            />
            {password.length > 0 ? <LinearProgress variant="determinate"
              size="sm"
              value={Math.min((strength?.length * 100) / 5, 100)}
              sx={{
                bgcolor: 'background.level3',
                color: 'hsl(var(--hue) 80% 40%)',
              }}
            /> : null}
            <Typography
              level="body-xs"
              sx={{ alignSelf: 'flex-end', color: 'hsl(var(--hue) 80% 30%)' }}
            >
              {strength?.length <= 2 && password && 'Very weak'}
              {strength?.length == 3 && 'weak'}
              {strength?.length > 3 && strength?.length < 5 && 'strong'}
              {strength?.length == 5 && ' Very strong'}
            </Typography>
          </Stack>
        </FormControl>

        <FormControl className="form-control">
          <InputLabel htmlFor="name-input">Confirm Password</InputLabel>
          <TextField
            variant="outlined"
            type={showConfirmPassword ? 'text' : 'password'}
            error={Boolean(confirmPasswordError)}
            helperText={confirmPasswordError}
            onBlur={handleConfirmPasswordBlur}
            placeholder='Repeat password'
            value={confirmPassword ?? ''}
            name='password'
            onChange={(e) => {
              const newValue = e.target.value;
              if (newValue.length <= 32) {
                setConfirmPassword(newValue);
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => handleClickShowPassword('confirmPassword')}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </FormControl>


        <Button
          // disabled={!numberVerified || !!phoneError}  // Disable button if numberVerified is false
          type='submit'
          onClick={HandleNewPassword}
          variant="contained"
          className="SinginFormBtn"
        >
          Submit
        </Button>

      </div>

      <ErrorPopup />
      {openSnackbar ? <CustomSnackBar
        openSnackbar={openSnackbar}
        snackBarMessage={customMsg?.msg}
        status={customMsg?.type}
        handleSnackbarClick={handleSnackbarClick}
      />


        : null}
    </div>
  );
}

export default CreatePasswordComponent;